import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl, intlShape } from 'react-intl';
import cx from 'classnames';
import { connect } from 'react-redux';
import queryString from 'query-string';
import snakeCaseKeys from 'snakecase-keys';
import withAdvert from 'shared/hocs/withAdvert';
import API from 'shared/constants/api';
import { bindActionCreators } from 'redux';
import { objectsToIDs } from 'shared/helpers/common';
import { setIsApprovePub } from 'shared/actions/globals';
import { getVehicleMicroMarkingJson, getProductMicroMarkingJson } from 'shared/helpers/advert';
import { DesktopButton, DesktopRightSidebar } from 'shared/components/BannerAll';
import {
  getFieldFromRootOrCharacteristics,
  getTransportInfoFiltered,
} from 'shared/helpers/transportInfo';
import JsonLdApplication from 'shared/components/JsonLdApplication/JsonLdApplication';
import LeasingOnlineBanner from 'shared/components/LeasingOnlineBanner/LeasingOnlineBanner';
import LeasingUlfBanner from 'shared/components/LeasingOnlineBanner/LeasingUlfBanner';
import CreditMarketBanner from 'shared/components/LeasingOnlineBanner/CreditMarketBanner';
import { generateUrl, generateSparesSearchUrl } from 'shared/helpers/urls';
import InfoMessages from 'desktop/components/InfoMessages/InfoMessages';
import SuccessBlock from 'shared/components/SuccessBlock/SuccessBlock';
import SoldMessage from 'shared/components/SoldMessage/SoldMessage';
import IrrelevantMessage from 'shared/components/IrrelevantMessage/IrrelevantMessage';
import InfoBlock from 'shared/components/InfoBlock/InfoBlock';
import AnotherCars from 'desktop/components/AnotherCars/AnotherCars';
import SparesForAdvert from 'shared/components/SparesForAdvert/SparesForAdvert';
import { isAnyLeasingAvailable } from 'shared/helpers/leasing/leasing';
import {
  isCreditmarketNotClearedProposalAvailable,
  isCreditmarketProposalAvailable,
} from 'shared/helpers/leasing/myAuto';
import SpecialAdvertCars from '../../components/SpecialAdvertCars/SpecialAdvertCars';
import SearchBar from './components/SearchBar/SearchBar';
import CarInfo from './components/CarInfo/CarInfo';

// eslint-disable-next-line css-modules/no-unused-class
import s from './Advert.css';

class Advert extends React.Component {
  static propTypes = {
    advertInfo: PropTypes.shape().isRequired,
    leasingParams: PropTypes.shape(),
    similarCars: PropTypes.arrayOf(PropTypes.shape()),
    agencyCars: PropTypes.arrayOf(PropTypes.shape()),
    videosAboutCar: PropTypes.arrayOf(PropTypes.shape()),
    spares: PropTypes.arrayOf(PropTypes.shape()),
    bestOffers: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    nextItemQueryString: PropTypes.string,
    count: PropTypes.number,
    userId: PropTypes.number,
    countToday: PropTypes.number,
    isShortView: PropTypes.bool.isRequired,
    clearIsApprovePub: PropTypes.func.isRequired,
    isApprovePub: PropTypes.bool.isRequired,
    //
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    similarCars: [],
    agencyCars: [],
    videosAboutCar: [],
    spares: [],
    nextItemQueryString: null,
    count: null,
    countToday: null,
    userId: null,
    leasingParams: null,
  };

  state = {
    nextItemLink: null,
  };

  componentDidMount() {
    const { nextItemQueryString } = this.props;
    if (nextItemQueryString)
      fetch(API.ADVERT.ALL(nextItemQueryString))
        .then(r => r.json())
        .then(r => r.results && r.results[0])
        .then(advert => {
          if (advert) {
            this.setState({ nextItemLink: generateUrl(advert) });
          }
        });
  }

  componentWillUnmount() {
    this.props.clearIsApprovePub(false);
  }

  render() {
    const {
      userId,
      similarCars,
      agencyCars,
      videosAboutCar,
      bestOffers,
      spares,
      count,
      countToday,
      advertInfo,
      advertInfo: {
        make,
        model,
        location,
        power,
        transport,
        power_unit: powerUnit,
        title,
        year,
        active: activeKey,
        sold = false,
        is_new: isNew,
        is_negotiable_price: isNegotiablePrice,
      },
      isShortView,
      intl,
      isApprovePub,
      leasingParams,
    } = this.props;
    const { nextItemLink } = this.state;

    const category = getFieldFromRootOrCharacteristics('category', advertInfo);
    const searchData = {
      make,
      model,
      category,
      location,
      power,
      powerUnit,
      transport,
      title,
      year,
      isNew,
      isNegotiablePrice,
    };
    const microMarkingProductJson = getProductMicroMarkingJson(advertInfo);
    const microMarkingVehicleJson = getVehicleMicroMarkingJson(advertInfo);
    const deleted = activeKey === -2;
    const active = isApprovePub || !!activeKey;
    const isAuto = transport && transport.slug === 'avto';
    const carInfoFilter = getTransportInfoFiltered(transport.slug);
    const sparesLink = `/${generateSparesSearchUrl({
      transport,
      make,
      model,
    })}`;
    const isLeasing = isAnyLeasingAvailable(advertInfo);
    const isCreditMarket =
      isCreditmarketNotClearedProposalAvailable(advertInfo) ||
      isCreditmarketProposalAvailable(advertInfo);
    return (
      <div className={s.page}>
        <InfoMessages countToday={countToday} />
        <div className={s.container}>
          <div className={s.flexRow}>
            <div className={cx(s.mainCell)}>
              <SearchBar searchData={searchData} nextItemLink={nextItemLink} />
              {isApprovePub && <SuccessBlock title={'Ваше объявление активировано'} />}

              {(sold || deleted || (!sold && !active)) &&
                <div>
                  {deleted &&
                    <InfoBlock title="Это объявление удалено и не принимает участие в поиске!" />}
                  {sold && !deleted && <SoldMessage />}
                  {!sold &&
                    !active &&
                    !isApprovePub &&
                    <IrrelevantMessage title="Это объявление уже неактуально" />}

                  {agencyCars.length > 0 &&
                    <AnotherCars
                      title={intl.formatMessage({ id: 'Объявления автосалона' })}
                      cars={agencyCars}
                    />}
                  {similarCars.length > 0 &&
                    <AnotherCars
                      title={intl.formatMessage({ id: 'Похожие объявления' })}
                      cars={similarCars}
                    />}
                </div>}
              <CarInfo
                carInfo={advertInfo}
                carInfoFilter={carInfoFilter}
                style={{ order: sold || !active ? '1' : null }}
                count={count}
                spares={spares}
                isShortView={isShortView}
                userId={userId}
                videosAboutCar={videosAboutCar}
                isApprovePub={isApprovePub}
                leasingParams={leasingParams}
              />
              <DesktopButton />
              {!sold &&
                !!active &&
                <div>
                  {agencyCars.length > 0 &&
                    <AnotherCars
                      title={intl.formatMessage({ id: 'Объявления автосалона' })}
                      cars={agencyCars}
                    />}
                  {similarCars.length > 0 &&
                    <AnotherCars
                      title={intl.formatMessage({ id: 'Похожие объявления' })}
                      cars={similarCars}
                    />}
                </div>}
            </div>
            <JsonLdApplication {...microMarkingProductJson} />
            <JsonLdApplication {...microMarkingVehicleJson} />
            <DesktopRightSidebar fixedSecondBanner>
              {isLeasing &&
                isCreditMarket &&
                isAuto &&
                /* TODO: temporary CreditMarketBanner disabled */
                <LeasingOnlineBanner advert={advertInfo} leasingParams={leasingParams} />}
              {/* <CreditMarketBanner
                  modalMode={false}
                  advert={advertInfo}
                  leasingParams={leasingParams}
                /> */}
              {isLeasing &&
                !isCreditMarket &&
                isAuto &&
                leasingParams &&
                advertInfo.is_new !== true &&
                <LeasingOnlineBanner advert={advertInfo} leasingParams={leasingParams} />}
              {isLeasing &&
                isAuto &&
                advertInfo.is_new === true &&
                <LeasingUlfBanner eventPostfix="advertcard-sidebar" advert={advertInfo} />}
              <SpecialAdvertCars cars={bestOffers} />
              {spares &&
                spares.length > 0 &&
                <SparesForAdvert
                  transport={transport}
                  make={make}
                  model={model}
                  spares={spares}
                  sparesLink={sparesLink}
                />}
            </DesktopRightSidebar>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ searchForm, globals: { isApprovePub } }, { nextSearchItemIndex }) => ({
  nextItemQueryString: nextSearchItemIndex
    ? `?${queryString.stringify(
        snakeCaseKeys(
          objectsToIDs({ ...searchForm.selected, page: nextSearchItemIndex, perPage: 1 }),
        ),
      )}`
    : null,
  isApprovePub,
});

const mapDispatchToProps = dispatch => ({
  clearIsApprovePub: bindActionCreators(setIsApprovePub, dispatch),
});

export default withStyles(s)(
  withAdvert(injectIntl(connect(mapStateToProps, mapDispatchToProps)(Advert))),
);



// WEBPACK FOOTER //
// ./src/desktop/routes/advert/Advert.js